import { Button } from "@/components/ui/button";

const HeroBanner = () => {
  const scrollToBooking = () => {
    const element = document.querySelector("#booking");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div 
      className="relative w-full h-[200px] md:h-[280px] overflow-hidden mt-14 md:mt-11"
      data-testid="hero-banner"
    >
      {/* Background Image - Pastel Sunset */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1768744781410-757053db2ab0?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1920')",
        }}
      />
      
      {/* Light Overlay for soft look */}
      <div className="absolute inset-0 bg-white/20" />
      
      {/* Content */}
      <div className="relative h-full flex flex-col items-center justify-center text-center px-6 pt-8">
        <h1 
          className="text-5xl md:text-6xl lg:text-7xl font-bold mb-4"
          style={{ 
            fontFamily: "'Dancing Script', cursive",
            color: "#2d2d2d",
            textShadow: "2px 2px 4px rgba(255,255,255,0.9)"
          }}
        >
          Thrive with Deepa
        </h1>
        <div className="bg-white/80 backdrop-blur-sm px-6 py-3 rounded-full mb-5 shadow-md">
          <p 
            className="text-base md:text-lg font-semibold"
            style={{ color: "#4A6741" }}
          >
            Leadership & Career Coaching for Mid-Career Professionals
          </p>
        </div>
        <Button
          onClick={scrollToBooking}
          size="lg"
          className="bg-primary text-white hover:bg-primary/90 px-6 py-5 text-base font-medium shadow-lg"
          data-testid="banner-cta"
        >
          Book a Discovery Call
        </Button>
      </div>
    </div>
  );
};

export default HeroBanner;
